import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
import FormItemLongDisplay from '../display/FormItemLongDisplay';
require('../../styles/FormItemRender.css');
export default class FormItemLongRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}
	
	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;

		_value = FormItemLongDisplay.getDisplayText(_value,this.props.showZero,this.props.thousandSeperator)

		return _value;
	}


	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{_value}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemLongRenderForAutoLookup.js